import { React, useState, useEffect } from "react";
import request from "../../../../Helpers/API";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { BuscadorModelosExcluidos } from "./BuscadorModelosExcluidos";
import RemoveCircleIcon from "@mui/icons-material/DeleteForever";

export const ExcluirModelosModal = ({ open, onClose }) => {
  const [datafiltro, setDatafiltro] = useState([]);
  const [estado, setEstado] = useState(false);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    onExecute();
  }, [open, estado]);

  const onExecute = () => {
    setLoader({ ...loader, mostrar: true });

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`DashboardPostventa/ModelosGarantia`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setDatafiltro(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const CambiarEstado = (id) => {
    Swal.fire({
      title: "¿Estás seguro que deseas eliminar esta regla?",
      text: "¡No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoader({ ...loader, mostrar: true });
        request
          .get(`DashboardPostventa/EliminarReglaExclusion?id=${id}`)
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire({
              title: "GARANTIAS",
              text: "Estado modificado con éxito",
              icon: "success",
              customClass: {
                container: "mi-superpoop",
              },
            });
            Swal.fire("Eliminado!", "La regla ha sido eliminada.", "success");
            setDatafiltro(result);
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            return;
          });

        // Aquí puedes ejecutar la acción, por ejemplo:
        // deleteItem(id);
      }
    });
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div className="excluir-modelos-modal-formulario">
          <div className="excluir-modelos-modal-plantilla">
            <div
              className="plantilla-screen-filtro-container"
              id="mdlFiltros-modal"
            >
              <PlantillaScreen
                titulo={"EXCLUIR GARANTIAS DE MODELOS"}
                className_main={1}
                className={"plantilla-screen-filtro-container-modal"}
              >
                <div className="cerrar-modal-button" onClick={onClose}>
                  X
                </div>
                <div className={`excluir-modelos-modal`}>
                  <div className="excluir-modelos-modal-container">
                    <BuscadorModelosExcluidos
                      setData={setDatafiltro}
                      setLoader={setLoader}
                      loader={loader}
                    />
                    <div className="excluir-modelos-modal-container-table scroll-4">
                      <table cellPadding={0} cellSpacing={0}>
                        <thead>
                          <tr>
                            {/* <th>ID</th>
                            <th> */}
                            <th>Serie</th>
                            <th>
                              <div>Tipo</div>
                            </th>
                            <th>
                              <div>Eliminar</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {datafiltro.map((item, index) => (
                            <tr key={index}>
                              {/* <td>{item.idexclusion}</td> */}
                              <td>{item.modelo}</td>
                              <td className="ta-center">
                                {item.tipo === "I" ? "Incluir" : "Excluir"}
                              </td>
                              <td
                                className="ta-center celda-estatus"
                                onClick={() => CambiarEstado(item.idexclusion)}
                              >
                                <RemoveCircleIcon sx={{ color: "#a30606" }} />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </PlantillaScreen>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
